export default __webpack_public_path__ + "static/media/company.a55e80a8.svg";